module.exports = __webpack_public_path__ + "static/media/USLUGA2.22a002e9.jpeg";